// subscriptionActions.js
import {
  FETCH_SUBSCRIPTION_START,
  FETCH_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_FAILURE,
} from "state/types/actionTypes";

import apiClient from "../../api/apiClient";

export const fetchSubscriptionStart = () => ({
  type: FETCH_SUBSCRIPTION_START,
});

export const fetchSubscriptionSuccess = (subscriptionData) => ({
  type: FETCH_SUBSCRIPTION_SUCCESS,
  payload: subscriptionData,
});

export const fetchSubscriptionFailure = (error) => ({
  type: FETCH_SUBSCRIPTION_FAILURE,
  payload: error,
});

export const fetchSubscription = () => async (dispatch) => {
  dispatch(fetchSubscriptionStart());
  try {
    const res = await apiClient.get(
      `${process.env.REACT_APP_BASE_URL}/payments/subscription-info`,
      { withCredentials: true },
    );
    dispatch(fetchSubscriptionSuccess(res.data)); // send full data like plan/credits
    return res.data;
  } catch (error) {
    // For guests or expired sessions, treat this as a non-fatal auth state and
    // avoid throwing, which causes uncaught runtime overlays in CRA.
    dispatch(
      fetchSubscriptionFailure(error.message || "Failed to fetch subscription"),
    );
    return null;
  }
};
